'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/slider.html'),
        transclude: true,
        scope: {
            translations: '=?myOptions',
            operator: '=myOperator',
            model: '=myValue',
        },
        controller: ['$scope', '$rootScope',
            function ($scope, $rootScope) {

                $scope.translations = angular.isDefined($scope.translations) ? $scope.translations : [
                    {
                        value: null,
                        text: '',
                        operator: null,
                    },
                    {
                        value: 2.5,
                        text: 'Менее 2.5',
                        operator: 'LT',
                    },
                    {
                        value: 2.5,
                        text: 'От 2.5',
                        operator: 'GE',
                    },
                    {
                        value: 20,
                        text: 'От 20',
                        operator: 'GE',
                    },
                    {
                        value: 30,
                        text: 'От 30',
                        operator: 'GE',
                    },
                    {
                        value: 50,
                        text: 'От 50',
                        operator: 'GE',
                    },
                    {
                        value: 100,
                        text: 'От 100',
                        operator: 'GE',
                    },
                    {
                        value: 120,
                        text: 'От 120',
                        operator: 'GE',
                    },
                    {
                        value: 150,
                        text: 'От 150',
                        operator: 'GE',
                    },
                    {
                        value: 250,
                        text: 'От 250',
                        operator: 'GE',
                    },
                    {
                        value: 300,
                        text: 'От 300',
                        operator: 'GE',
                    },
                    {
                        value: 500,
                        text: 'От 500',
                        operator: 'GE',
                    },
                    {
                        value: 1000,
                        text: 'От 1 млрд',
                        operator: 'GE',
                    },
                    {
                        value: 1500,
                        text: 'От 1.5 млрд',
                        operator: 'GE',
                    },
                    {
                        value: 5000,
                        text: 'От 5 млрд',
                        operator: 'GE',
                    },
                ];

                $scope.slider = {
                    value: $scope.translations.findIndex(item => item.value == $scope.model && item.operator === $scope.operator),
                    options: {
                        noSwitching: true,
                        showTicksValues: true,
                        showSelectionBar: true,
                        stepsArray: $scope.translations.map((item, index) => {
                            if (index % 2 !== 0) {
                                return { value: index, legend: item.text };
                            } else {
                                return { value: index };
                            }
                        }),
                        translate: function(value) {
                            if (value % 2 !== 0) {
                                return '';
                            } else {
                                return $scope.translations[value].text;
                            }
                        }
                    }
                }

                $scope.$watchGroup(['model', 'operator'], (newValue, oldValue, scope) => {
                    $scope.slider.value = $scope.translations.findIndex(item => item.value == scope.model && item.operator === scope.operator);
                })

                $scope.$watch('slider.value', (newValue, oldValue, scope) => {
                    const valueTranslation = $scope.translations[$scope.slider.value];
                    if (valueTranslation) {
                        $scope.model = valueTranslation.value;
                        $scope.operator = valueTranslation.operator;
                    }
                })
            }]
    };
}
